import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { InsuranceCase } from '../../../../app-create-case/models/insurance-case.model';
import { ShellDomainProvider } from '../../../standalone-packages/ecap3/core';

@Component({
    selector: 'app-linked-ipex-upload-cases',
    templateUrl: './linked-ipex-upload-cases.component.html',
    styleUrls: ['./linked-ipex-upload-cases.component.scss'],
    standalone: false
})
export class AppLinkedIpexUploadCasesComponent {
    //Input section
    @Input() uploadIpexCaseInfo: InsuranceCase;

    constructor(
        private router: Router,
        public readonly translateService: TranslateService
    ) {}

    gotoUploadIpex() {
        const url = `${ShellDomainProvider['api']['caseCenterUri']}/cases/detail/${this.uploadIpexCaseInfo.ItemId}`;
        return url;
    }
}
